"use client";

import { useSyncExternalStore } from "react";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Reads the preference once, for code that only needs it at event time (a
 * click that decides between a smooth and an instant scroll). Subscribing
 * through the hook instead makes the component part of a synchronous
 * re-render after hydration, because the server snapshot below deliberately
 * differs from what most visitors' browsers report.
 */
export function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia(REDUCED_MOTION_QUERY).matches
  );
}

export function usePrefersReducedMotion() {
  const subscribe = (onChange: () => void) => {
    const mql = window.matchMedia(REDUCED_MOTION_QUERY);
    const handler = () => onChange();
    if (mql.addEventListener) mql.addEventListener("change", handler);
    else mql.addListener(handler); // Safari fallback
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", handler);
      else mql.removeListener(handler);
    };
  };

  // On the server, assume "reduce" to avoid any initial motion flash
  return useSyncExternalStore(subscribe, prefersReducedMotion, () => true);
}
